import { render, staticRenderFns } from "./BoostProperty.vue?vue&type=template&id=89c1ffe0"
import script from "./BoostProperty.vue?vue&type=script&lang=js"
export * from "./BoostProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports